/**
 * The crew member's tracking status on the producer's live map.
 *
 * The rule itself (status, label, explanation) lives in @produce/shared so the
 * PROduce Producer app's crew list says exactly the same — see
 * packages/shared/src/crewTrackingStatus.ts. Only the web's Tailwind badge
 * styling stays here.
 */

import type { CrewTrackingStatus } from "@produce/shared";

export {
  STATIONARY_AFTER_MS,
  crewTrackingExplanation,
  crewTrackingLabel,
  crewTrackingStatus,
  type CrewTrackingInput,
  type CrewTrackingStatus,
} from "@produce/shared";

/** Shared by all four badges, so only the colours differ per status. */
const BADGE_BASE = "px-1.5 py-0 text-[10px]";

/** `Record` over the union: a new status fails to compile until it has a style. */
const BADGE_CLASS: Record<CrewTrackingStatus, string> = {
  "tracking-off": BADGE_BASE + " bg-muted text-muted-foreground",
  "no-signal": BADGE_BASE + " bg-muted text-muted-foreground",
  stationary: BADGE_BASE + " border-yellow-500/30 bg-yellow-500/20 text-yellow-500",
  active: BADGE_BASE + " border-primary/30 bg-primary/20 text-primary",
};

/** Tailwind classes for the status badge. */
export function crewTrackingBadgeClass(status: CrewTrackingStatus): string {
  return BADGE_CLASS[status];
}
